import React from 'react';
import {
    Columns2,
    Grid2x2,
    Heading,
    Image as ImageIcon,
    LucideIcon,
    Megaphone,
    MousePointerClick,
    PanelLeft,
    PanelTop,
    RectangleHorizontal,
    RectangleVertical
} from 'lucide-react';
import { CommunityWhitelabelDashboardWidgetLayout } from '@api/ChallengeClient';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue
} from '@components/ui/select';

const Layout = CommunityWhitelabelDashboardWidgetLayout;

const LAYOUT_OPTIONS: {
    layout: CommunityWhitelabelDashboardWidgetLayout;
    label: string;
    hint: string;
    icon: LucideIcon;
}[] = [
    {
        layout: Layout.HERO,
        label: 'Hero',
        hint: 'Image on top, text below',
        icon: PanelTop
    },
    {
        layout: Layout.HEADLINE,
        label: 'Headline',
        hint: 'Title above the image',
        icon: Heading
    },
    {
        layout: Layout.COMPACT,
        label: 'Compact',
        hint: 'Small thumbnail beside the text',
        icon: PanelLeft
    },
    {
        layout: Layout.SPLIT,
        label: 'Split',
        hint: 'Text left, image right',
        icon: Columns2
    },
    {
        layout: Layout.BANNER,
        label: 'Banner',
        hint: 'Text over a wide image',
        icon: ImageIcon
    },
    {
        layout: Layout.POSTER,
        label: 'Poster',
        hint: 'Text over a tall image',
        icon: RectangleVertical
    },
    {
        layout: Layout.ACCENT,
        label: 'Accent',
        hint: 'Community colour, no image',
        icon: Megaphone
    },
    {
        layout: Layout.STRIP,
        label: 'Strip',
        hint: 'One line, title only',
        icon: RectangleHorizontal
    },
    {
        layout: Layout.CALL_TO_ACTION,
        label: 'Call to action',
        hint: 'Hero with a button',
        icon: MousePointerClick
    },
    {
        layout: Layout.TILE,
        label: 'Tile',
        hint: 'Square, two tiles in a row',
        icon: Grid2x2
    }
];

export const LayoutSelect = ({
    value,
    onChange
}: {
    value: CommunityWhitelabelDashboardWidgetLayout;
    onChange(layout: CommunityWhitelabelDashboardWidgetLayout): void;
}) => (
    <Select
        value={value}
        onValueChange={(layout) =>
            onChange(layout as CommunityWhitelabelDashboardWidgetLayout)
        }
    >
        <SelectTrigger size="sm" aria-label="Layout" className="w-44">
            <SelectValue />
        </SelectTrigger>
        <SelectContent>
            {LAYOUT_OPTIONS.map(({ layout, label, hint, icon: Icon }) => (
                <SelectItem key={layout} value={layout} textValue={label}>
                    <Icon />
                    <span>{label}</span>
                    <span className="text-xs text-muted-foreground in-data-[slot=select-value]:hidden">
                        {hint}
                    </span>
                </SelectItem>
            ))}
        </SelectContent>
    </Select>
);
